import { Component, OnInit } from '@angular/core';
import { DataService, ISupplier } from '../../shared/data.service';

@Component({
  selector: 'pcc-select-supplier',
  templateUrl: './select-supplier.component.html',
  styleUrls: ['./select-supplier.component.css']
})
export class SelectSupplierComponent implements OnInit {
  suppliers: ISupplier[];
  selectedSupplier: any;
  filteredSuppliers: any[];

  constructor(private dataService: DataService) { }

  async ngOnInit(): Promise<void> {
    this.suppliers = await this.dataService.getSuppliers();
  }

  selectSupplier(supplier: ISupplier) {
    this.dataService.supplier = this.selectedSupplier = supplier;
  }

  filterSupplier(event: any) {
    this.filteredSuppliers = this.suppliers.filter((supplier) => supplier.name.toLowerCase().indexOf(event.query.toLowerCase()) === 0);
  }
}
